export const inputnumberTokens = {
  inputnumber: {
    root: {
      transitionDuration: '{transition.duration}'
    },
    button: {
      background: 'transparent',
      borderColor: '{formField.borderColor}',
      color: '{formField.color}',
      hoverBackground: '{formField.hoverBorderColor}',
      hoverBorderColor: '{formField.hoverBorderColor}',
      hoverColor: '{formField.color}',
      activeBackground: '{formField.background}',
      activeBorderColor: '{formField.focusBorderColor}',
      activeColor: '{formField.color}'
    }
  }
};

export type InputNumberTokens = typeof inputnumberTokens;
